var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipe-pagination"},_vm._l((_vm.pages),function(_,index){return _c('div',{key:index,staticClass:"swipe-pagination__item",class:{ 'swipe-pagination__item-active': index + 1 === _vm.page }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }